
export const OpenDrawer = "open-drawer";
export const OpenReportsDrawer = "open-reports-drawer";
export const OpenFailuresDrawer = "open-failures-drawer";

export const SubMenuEvents = "sub-menu-events";
export const EventTypeConsentModalOpen = "ConsentModalOpen";
export const EventTypeClickEPrescribe = "EPrescribe";
export const EventTypeScriptSureRelatedAddNewMedication = "ScriptSureRelated-add-new-medication";
export const EventTypeScriptSureRelatedApproveMedicationsView = "ScriptSureRelated-approve-medications-view";
export const EventTypeScriptSureRelatedMedicationsHistory = "ScriptSureRelated-medications-history";
